import { Text } from '@wix/design-system';
import React from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { getEditorCapabilitiesForHost } from '../../utils/editor-host-to-editor-type';
import { buildStudioDialogProps } from './build-studio-dialog-props';
export const getSaveBeforeLeaveModalProps = (t, editorHost) => {
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  return {
    content: usesClassicModalChrome ? t('accessibility-wizard.save-changes-modal.content') : /*#__PURE__*/React.createElement(Text, null, t('accessibility-wizard.save-changes-modal.content')),
    primaryButtonText: t('accessibility-wizard.save-changes-modal.primary-button'),
    secondaryButtonText: t('accessibility-wizard.save-changes-modal.secondary-button'),
    skin: 'standard',
    title: t('accessibility-wizard.save-changes-modal.title')
  };
};
export const showSaveBeforeCloseModal = async _ref => {
  let {
    biLogger,
    handleApply,
    a11yWizardAdapter,
    t,
    handleDiscard,
    editorHost
  } = _ref;
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  const modalProps = {
    ...getSaveBeforeLeaveModalProps(t, editorHost),
    primaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.Save,
        modalType: BiModalTypes.SaveBeforeLeaving
      });
      handleApply();
    },
    secondaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.DiscardChanges,
        modalType: BiModalTypes.SaveBeforeLeaving
      });
      handleDiscard();
    }
  };
  biLogger.modalView({
    modalType: BiModalTypes.SaveBeforeLeaving
  });
  if (usesClassicModalChrome) {
    await a11yWizardAdapter.showDialog({
      ...modalProps,
      theme: modalProps.skin
    });
    return;
  }
  await a11yWizardAdapter.showDialog(...buildStudioDialogProps(modalProps));
};
//# sourceMappingURL=show-save-before-leave-modal.js.map